import { Button, type ButtonProps } from "@chakra-ui/react"
import { FormattedMessage } from "react-intl"

import { ArrowRightIcon } from "@/components/Icons"

// Stepper "next" button. Children replace the default "Next" label (a flow can use its own key).
export const NextStepButton: React.FC<ButtonProps> = ({ children, ...props }) => (
  <Button display="flex" gap="2" type="submit" variant="outline" w="300px" {...props}>
    {children ?? (
      <FormattedMessage id="clientSheet.inheritanceTab.interBu.modal.stepper.nextStep" />
    )}
    <ArrowRightIcon boxSize={4} />
  </Button>
)
